/*
export const someAction = (state) => {}
 */
import { api } from 'src/plugins/axios'
import { draftAddress } from 'src/utils/addressVerification'
import Vue from 'vue'
import { createQueryString, serializeObject, } from 'src/utils'
import { notify } from 'src/plugins/notify'

export default {
  fetchAll,
  fetchDraftStudents,
  saveDraftStudents,
  complete,
}

async function fetchAll({ commit, state }, { pagination, filter, columns, }) {
  commit('setLoading', true)
  try {
    const query = createQueryString({ pagination, filter, columns, })
    let fieldQuery

    let finalSearchFields = _.pickBy(state.searchFields, v => {
        return v !== null && v !== '' && (typeof v === 'string' ? v.trim() !== '' : 1)
    })

    if (!_.isEmpty(finalSearchFields)) {
        fieldQuery = serializeObject({ searchFields: { ...finalSearchFields } })
    }

    let finalQuery = query + (fieldQuery ? '&' + fieldQuery : '')

    const { data } = await api.get('/jobs/fetchAll/' + finalQuery)
    if (data && !data.error && data.payload) {
      commit('setList', { jobs: data.payload.jobs })
      return data
    }

    notify.create({
      message: "Error loading jobs",
      type: "negative"
    })

    return null
  } catch (err) {
    console.log('error', err)
  } finally {
    commit('setLoading', false)
  }
}

async function fetchDraftStudents({ state, commit, dispatch, rootState }, { jobId }) {
  commit('setDraftStudentsLoading', true)
  try {
    const { data } = await api.get(`/jobs/fetchDraftStudents/${jobId}`)
    if (data && !data.error && data.payload) {
      // Drafts an earlier Finish held back because Google could not confirm
      // their address show as Unverified until the address is changed.
      dispatch('addressVerification/seed', {
        status: 'unverified',
        addresses: data.payload.students
          .filter(draft => draft.ADDRESS_STATUS === 'unverified')
          .map(draft => draftAddress(draft, rootState.shared.states)),
      }, { root: true })

      commit('setDraftStudents', data.payload.students)
      return data
    }
  } catch (err) {
    console.log('error', err)
  } finally {
    commit('setDraftStudentsLoading', false)
  }
}

async function saveDraftStudents({ state, commit, }) {
  try {
    await api.post('/jobs/saveDraftStudents/', {
      students: state.draftStudents,
    })
  } catch (err) {
    console.log('error', err)
  }
}

async function complete({ state, commit, }) {
  try {
    const job = state.currentJob

    const response = await api.post(`/jobs/complete/${job.ROSTER_JOB_ID}`, {
      job,
    })

    // { imported, heldBack } on success; null when the Finish failed and
    // nothing was imported
    const data = response && response.data
    return data && data.success ? data.payload : null
  } catch (err) {
    console.log('error', err)
    return null
  }
}

